<template>
    <div id="verify_email">
    </div>
</template>

<script>
    import AccountService from '@/api-services/account.service'
    import {EventBus} from '@/eventbus';

    export default {
        name: "VerifyEmail",
        async mounted() {
            await AccountService.verify_email(this.$route.params.token)
            EventBus.$emit('alert', {variant: 'success', message: this.$t('system.email_updated')})
            this.$router.push('/account')
        }
    }
</script>

<style scoped>

</style>
